import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getConsultantPortalMe = async () => {
  const response = await axios.get(`${BASE_URL}/consultant-portal/me`);
  return response.data;
};

export const listConsultantActivityReports = async () => {
  const response = await axios.get(`${BASE_URL}/consultant-portal/activity-reports`);
  return response.data;
};

export const createConsultantActivityReport = async (payload) => {
  const response = await axios.post(`${BASE_URL}/consultant-portal/activity-reports`, payload);
  return response.data;
};

export const updateConsultantActivityReport = async (reportId, payload) => {
  const response = await axios.patch(
    `${BASE_URL}/consultant-portal/activity-reports/${reportId}`,
    payload
  );
  return response.data;
};

export const submitConsultantActivityReport = async (reportId) => {
  const response = await axios.post(
    `${BASE_URL}/consultant-portal/activity-reports/${reportId}/submit`
  );
  return response.data;
};

export const listConsultantLeaveRequests = async () => {
  const response = await axios.get(`${BASE_URL}/consultant-portal/leave-requests`);
  return response.data;
};

export const createConsultantLeaveRequest = async (payload) => {
  const response = await axios.post(`${BASE_URL}/consultant-portal/leave-requests`, payload);
  return response.data;
};

export const updateConsultantLeaveRequest = async (requestId, payload) => {
  const response = await axios.patch(
    `${BASE_URL}/consultant-portal/leave-requests/${requestId}`,
    payload
  );
  return response.data;
};

export const submitConsultantLeaveRequest = async (requestId) => {
  const response = await axios.post(
    `${BASE_URL}/consultant-portal/leave-requests/${requestId}/submit`
  );
  return response.data;
};

export const cancelConsultantLeaveRequest = async (requestId) => {
  const response = await axios.post(
    `${BASE_URL}/consultant-portal/leave-requests/${requestId}/cancel`
  );
  return response.data;
};

export const listConsultantAssignments = async () => {
  const response = await axios.get(`${BASE_URL}/consultant-portal/assignments`);
  return response.data;
};

export const listConsultantAssignmentFeedback = async (params = {}) => {
  const response = await axios.get(`${BASE_URL}/consultant-portal/assignment-feedback`, {
    params,
  });
  return response.data;
};

export const createConsultantAssignmentFeedback = async (payload) => {
  const response = await axios.post(`${BASE_URL}/consultant-portal/assignment-feedback`, payload);
  return response.data;
};

export const updateConsultantAssignmentFeedback = async (feedbackId, payload) => {
  const response = await axios.patch(
    `${BASE_URL}/consultant-portal/assignment-feedback/${feedbackId}`,
    payload
  );
  return response.data;
};

export const submitConsultantAssignmentFeedback = async (feedbackId) => {
  const response = await axios.post(
    `${BASE_URL}/consultant-portal/assignment-feedback/${feedbackId}/submit`
  );
  return response.data;
};

export const getConsultantDashboard = async () => {
  const response = await axios.get(`${BASE_URL}/consultant-portal/dashboard`);
  return response.data;
};

export const getConsultantCalendar = async (year, month) => {
  const response = await axios.get(`${BASE_URL}/consultant-portal/calendar`, {
    params: { year, month },
  });
  return response.data;
};
